import { Injectable, signal } from '@angular/core';
import type { BuildKind } from '@sim/content/subject-kind';
import type { GridPos } from '@sim/core/types';

export type ToolId = BuildKind;

@Injectable({ providedIn: 'root' })
export class BuildToolService {
  readonly selectedCell = signal<GridPos | null>(null);

  deselect(): void {
    this.selectedCell.set(null);
  }

  selectCell(pos: GridPos | null): void {
    this.selectedCell.set(pos);
  }
}
